import { theme } from '@frontend/theme';
import { Heading, SkeletonLoaders, Text } from '@frontend/design-system';

type Props = {
  isError: boolean;
  isLoading: boolean;
  count: number;
  children: React.ReactNode;
};

export const MessageCount = ({ children, count, isError, isLoading }: Props) => {
  return (
    <SkeletonLoaders isLoading={isLoading}>
      <div
        css={{
          border: `solid 1px ${theme.colors.neutral20}`,
          borderRadius: theme.borderRadius.medium,
          color: isError ? theme.font.colors.error : theme.colors.neutral90,
          marginRight: theme.spacing(2),
          minWidth: '270px',
          padding: theme.spacing(2),
        }}
      >
        <Heading level={2} css={{ color: 'inherit', lineHeight: 1, marginBottom: theme.spacing(1) }}>
          <SkeletonLoaders.Loader width={50} isText>
            {count.toLocaleString()}
          </SkeletonLoaders.Loader>
        </Heading>
        <Text css={{ color: 'inherit', position: 'relative' }}>
          <SkeletonLoaders.Loader height={24}>{children}</SkeletonLoaders.Loader>
        </Text>
      </div>
    </SkeletonLoaders>
  );
};
